import axios from "axios";
import { getToken } from "@/utils/auth";
import { tansParams} from "@/utils/util";
import { Message, MessageBox } from "element-ui";
import store from "@/store";
import router from "@/router";
import cache from "@/utils/cache";
//引入进度条插件
import NProgress from "nprogress";
//引入进度条的样式
import "nprogress/nprogress.css";

// 是否显示重新登录
export let isRelogin = { show: false };


const requests = axios.create({
  baseURL: process.env.VUE_APP_BASE_API+'', // 'http://192.168.2.142:8899', // http://192.168.2.142:8899',
  //baseURL: "/hospital",
  timeout: 10000,
  withCredentials: true //让ajax携带cookie/session
});

// 添加请求拦截器
requests.interceptors.request.use(
  config => {
    // console.log('token', getToken(), this.$store)
    //在发送请求之前做些什么
    const isToken = (config.headers || {}).isToken === false; // 是否需要设置 token
    // 是否需要防止数据重复提交
    const isRepeatSubmit = (config.headers || {}).repeatSubmit === false;
    if (getToken() && !isToken) {
      config.headers["Authorization"] = getToken(); // 'Bearer ' + 让每个请求携带自定义token 请根据实际情况自行修改
    }
    // config.headers['Authorization'] = 'eyJhbGciOiJIUzUxMiJ9.eyJsb2dpbl91c2VyX2tleSI6ImUxMDRmMzBjLWNiNjktNDhhMi05ZGRiLWQ0ODg4OTQ0ZjUzYiJ9.Es991gdGNovunY0EWhTVNeqbg7lMk4ZGCzloYlpcmJs-r3iRYJf9Ry3COWr7ZRu9HFk2sJVDeWwHQxvrHAIJzg'
    // get请求映射params参数
    if (config.method === "get" && config.params) {
      let url = config.url + "?" + tansParams(config.params);
      url = url.slice(0, -1);
      config.params = {};
      config.url = url;
    }
    // !isRepeatSubmit &&
    // if ((config.method === 'post' || config.method === 'put')) {
    //   const requestObj = {
    //     url: config.url,
    //     data: typeof config.data === 'object' ? JSON.stringify(config.data) : config.data,
    //     time: new Date().getTime()
    //   }
    //   const requestSize = Object.keys(JSON.stringify(requestObj)).length; // 请求数据大小
    //   const limitSize = 5 * 1024 * 1024; // 限制存放数据5M
    //   if (requestSize >= limitSize) {
    //     console.warn(`[${config.url}]: ` + '请求数据大小超出允许的5M限制，无法进行防重复提交验证。')
    //     return config;
    //   }
    //   const sessionObj = cache.session.getJSON('sessionObj')
    //   if (sessionObj === undefined || sessionObj === null || sessionObj === '') {
    //     cache.session.setJSON('sessionObj', requestObj)
    //   } else {
    //     const s_url = sessionObj.url;                  // 请求地址
    //     const s_data = sessionObj.data;                // 请求数据
    //     const s_time = sessionObj.time;                // 请求时间
    //     const interval = 1000;                         // 间隔时间(ms)，小于此时间视为重复提交
    //     if (s_data === requestObj.data && requestObj.time - s_time < interval && s_url === requestObj.url) {
    //       const message = '数据正在处理，请勿重复提交';
    //       console.warn(`[${s_url}]: ` + message)
    //       return Promise.reject(new Error(message))
    //     } else {
    //       cache.session.setJSON('sessionObj', requestObj)
    //     }
    //   }
    // }
    // config.headers.token = localStorage.getItem("token") || "";
    //进度条开始动
    // NProgress.start()
    return config;
  },
  error => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);


const localHost = window.location.hostname;  //获取本地地址
// 判断是否需要替换（公网访问时才替换）
const needReplace = localHost === '222.221.86.126'; 
const replacer = (obj) => {
  if (typeof obj === 'string') {
      return obj.replace(/172\.20\.1\.60/g, '222.221.86.126');
  } else if (typeof obj === 'object' && obj !== null) {
      for (const key in obj) {
          obj[key] = replacer(obj[key]);
      }
  }
  return obj;
};
// 添加响应拦截器
requests.interceptors.response.use(
  res => {
    // 对响应数据做点什么
    // console.log(res, '响应的数据')
    if (res.status == 200) {
      if (res.data.code === 401) {
        store.commit("user/RESET_INFO");
        console.log(router.resolve({ path: "/login" }), this.$router);
        // store.dispatch('user/LogOut')
        MessageBox.confirm(
          "登录状态已过期，您可以继续留在该页面，或者重新登录",
          "系统提示",
          {
            confirmButtonText: "重新登录",
            cancelButtonText: "取消",
            type: "warning"
          }
        ).then(() => {
          // isRelogin.show = false;
          store.dispatch("user/LogOut").then(() => {
            // location.href = '/login';
            const path = router.resolve({ path: "/login" });
            window.open(path.href, "_blank");
          });
        });
        // Message({ message: res.data.msg, type: 'error' })
        // const adminStore = useAdminStore();
        // ElMessage({
        //   type: "info",
        //   message:res.data.msg,
        // });
        // adminStore.loginOut(); // 退出登录
        return Promise.reject(res);
      }

      // 公网访问时文件地址处理
      const paramStr = JSON.stringify(res.data|| {});
      if (paramStr.includes('172.20.1.60')&&needReplace) {
        res.data = replacer(res.data);
      }

      return Promise.resolve(res.data);
    } else {
      return Promise.reject(res || {});
    }
    //进度条结束
    // NProgress.done()
    return res ? res.data : {};
  },
  error => {
    // 超时处理
    let originalRequest = error.config;
    if (
      error.code === "ECONNABORTED" &&
      error.message.indexOf("timeout") !== -1 &&
      !originalRequest._retry
    ) {
      // this.$message.error('请检查网络再重新连接');
      // ElMessage({
      //   type: "error",
      //   message: "请检查网络再重新连接",
      // });
      return Promise.reject("请检查网络再重新连接");
    }
    if (error.response && error.response.status) {
      return Promise.reject(error.response);
    }
    // 对响应错误做点什么
    // return Promise.reject(error);
  }
);

export default requests;



// WEBPACK FOOTER //
// ./src/utils/request.js